import React from 'react'
import styles from "./schoolRitualBlockSix.module.css"
import LazySection from '../LazySection'


function SchoolRitualBlockSix({theUranusArchetypeRef,theNeptuneArchetypeRef,thePlutoArchetypeRef,alignmentWithTheZodiacRef, ariesInvocationRef, taurasInvocationRef, geminiInvocationRef, cancerInvocationRef}) {
    return (
        <>
            <div className={styles.school_ritual_psd6_mainWrp}>
                {/* ---------------------------block1------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block1_mainWrp}`} >
                        <div className={styles.common_width}>
                            {/* <div className={styles.column}>
                                <div className={`${styles.col12} ${styles.bgifive}`}>
                                    <h2>
                                        The Uranus Archetype - Divine Intelligence</h2>
                                </div>
                            </div> */}


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h2 ref={theUranusArchetypeRef}>Uranus Invocation</h2>
                                        <h6>The Uranus Archetype - Divine Intelligence</h6>
                                        <h3>1. Stabilizing Chaos </h3>

                                        <p>
                                            By consciously banishing traits like chaos and rebellion without cause, you cultivate a more
                                            structured approach to innovation and change. This purification allows you to channel your energies more constructively, ensuring that your efforts to disrupt the status quo are meaningful and not
                                            just reactionary.


                                        </p>
                                        <h3>2. Fostering Innovation and Originality</h3>



                                        <p>
                                            Invoking Uranus’s qualities such as innovation, freedom, and originality energizes your creative processes and encourages you to think outside the traditional frameworks. As these traits are strengthened, you find yourself more adept at generating unique ideas and solutions that can lead to significant breakthroughs.

                                        </p>
                                        <h3>3. Embracing Technological Advancements</h3>
                                        <p>
                                            Uranus influences daily activities that involve engaging with technology and futuristic concepts. By actively trying new technologies and staying abreast of technological advancements, you harness Uranus’s energy of progress and invention, which can significantly enhance your personal and
                                            professional life. </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd6_block1_mainWrp_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block2------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block2_mainWrp}`}>
                        <div className={styles.common_width}>



                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h3>4. Openness to Sudden Insights</h3>

                                        <p>
                                            Being open to sudden insights and unconventional ideas aligns you with the spontaneous and
                                            sometimes disruptive energy of Uranus. This openness can lead to rapid shifts in perspective
                                            that are transformative, providing you with deeper understanding and novel approaches to
                                            life’s challenges.


                                        </p>
                                        <h3>5. Driving Social and Cultural Reform</h3>



                                        <p>
                                            Engaging in activities that involve reform or breaking societal norms embodies Uranus’s qualities of revolution and change. Whether through social movements, inventions, or advocacy, your actions can initiate or contribute to significant transformations in your community or field, reflecting Uranus’s role in pushing the boundaries of what is possible.

                                        </p>

                                        <p>
                                            Through this ritual praxis, you refine your ability to perceive and integrate the archetypal power of Uranus directly. This integration results in a transformative effect on your ability to innovate and adapt, encouraging you to embrace change and originality in a way that fosters growth and progress both personally and collectively. </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1199}`}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd6_block2_mainWrp_bg.webp"
                                        alt='Image'
                                    />

                                     <img
                                        className={`${styles.school_ritual_img1} ${styles.school_ritual_img1_1920}`}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd6_block2_mainWrp_bg_new.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>


                {/* ---------------------------block3------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block3_mainWrp}`}>
                        <div className={styles.common_width}>



                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h6>Ritual Praxis of the Planetary Intelligence</h6>

                                        <p>
                                            Once completing the opening of the gates of air, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and
                                            infinite self, make the gesture of Uranus. Hold for one to three full breaths then make the
                                            pronouncement and resonate the Divine Name of the Planetary Intelligence.


                                        </p>




                                        <p>
                                            <span>Pronouncement: "In nomine Caeli, caelorum innovatoris,"</span>


                                        </p>

                                        <p>
                                            <span>Translation: "In the name of Caelus, innovator of the heavens,"</span> </p>
                                        <p><span>Phonetics: "In noh-mee-nay Kai-lee, kai-loh-room in-noh-vah-toh-rees,"</span></p>
                                        <div className={styles.clippathsec}><p>Resonate Divine Name <span>(1 to 3 times)</span></p></div>
                                        <p><span className={styles.color_white}> Uranus / Latin : </span> <span>Caelus (KAI-loos)  -KAAAAAAIIIIII-looooooos</span></p>
                                        <div className={styles.clippathsecnoteSEc}><p><span>Note:</span> The name Uranus is from Greek mythology, and the Romans equated Caelus as the god
                                            of the sky, akin to the Greek Ouranos.</p></div>
                                        <p>If banishing, focus on a purification of Uranus’s Archetype within the personal psychology and energetic being. If invoking, focus on the unity between the self and the self boundary as a total unity allowing the Divine Intelligence of the Higher Being of Uranus to possess and transform.  Hold the sign of
                                            silence for at least three full breaths afterward focusing on the purity of the Archetype if Banishing or allowing the Planetary Intelligence to fully embody if Invoking. </p>

                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/school_ritual_psd6_block3_mainWrp_bg_new.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>


                {/* ---------------------------block4------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block4_mainWrp}`} >
                        <div className={styles.common_width}>
                            {/* <div className={styles.column}>
                                <div className={`${styles.col12} ${styles.bgifive}`}>
                                    <h2>
                                        The Neptune Archetype - Divine Intelligence</h2>
                                </div>
                            </div> */}


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h2 ref={theNeptuneArchetypeRef}>Neptune Invocation</h2>
                                        <h6>The Neptune Archetype - Divine Intelligence</h6>
                                        <h3>1. Clearing Delusion and Escapism</h3>

                                        <p>
                                            By consciously banishing traits like delusion, addiction, and escapism, you foster a more grounded and realistic approach to your emotional and spiritual life. This purification helps you distinguish between healthy spiritual or artistic engagements and those that serve as mere distractions from reality.


                                        </p>
                                        <h3>2. Enhancing Spiritual Connection and Intuition</h3>



                                        <p>
                                            Invoking Neptune’s qualities such as spiritual connection, compassion, and intuition deepens your
                                            understanding of yourself and your connection to the universe. As these traits are strengthened, you become more attuned to the subtle energies and messages from your subconscious, enhancing your spiritual practices and intuitive abilities.

                                        </p>
                                        <h3>3. Cultivating Artistic Inspiration</h3>
                                        <p>
                                            Neptune influences daily activities that involve the arts and creativity. By engaging in artistic pursuits, whether through creating art or appreciating it, you tap into Neptune’s energy of inspiration and creativity. This not only enriches your artistic expression but also allows you to explore deeper
                                            emotional and spiritual themes through your creations.</p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd6_block4_mainWrp_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block5------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block5_mainWrp}`}>
                        <div className={styles.common_width}>



                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h3>4. Fostering Compassion and Healing</h3>

                                        <p>
                                            Engaging in volunteer work or activities that require empathy and compassion embodies Neptune’s qualities of selflessness and healing. This practice not only benefits those you help but also
                                            enriches your own soul, deepening your understanding of the interconnectedness of all life.


                                        </p>
                                        <h3>5. Connecting with Like-Minded Communities</h3>



                                        <p>
                                            By connecting with spiritual or artistic communities, you engage with others who share your values and interests. This communal interaction can provide support and inspiration, helping you to further develop your spiritual and artistic pursuits, which are integral aspects of Neptune’s influence.

                                        </p>

                                        <p>

                                            Through this ritual praxis, you refine your ability to perceive and integrate the archetypal power of
                                            Neptune directly. This integration results in a transformative effect on your emotional, spiritual, and artistic faculties, enhancing your capacity for compassion, creativity, and intuition. It encourages a deeper connection with the spiritual and artistic realms, leading to a more fulfilled and
                                            meaningful existence.</p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/school_ritual_psd6_block5_mainWrp_bg_new.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block6------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block6_mainWrp}`}>
                        <div className={styles.common_width}>



                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h6>Ritual Praxis of the Planetary Intelligence</h6>

                                        <p>
                                            Once completing the opening of the gates of water, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total
                                            immortal and infinite self, make the gesture of Neptune. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Planetary Intelligence.


                                        </p>



                                        <p>
                                            <span>Pronouncement: "In nomine Neptuni, dominator marium et visionum,"</span>


                                        </p>
                                        <p><span>Translation: "In the name of Neptunus, ruler of the seas and visions,"</span></p>
                                        <p><span>Phonetics: "In noh-mee-nay Nep-too-nee, doh-mee-nah-tor mah-ree-oom et vee-see-oh-noom,"</span></p>

                                        <div className={styles.clippathsec}><p>Resonate Divine Name <span>(1 to 3 times)</span></p></div>
                                        <p><span className={styles.color_white}> Neptune / Latin: </span> <span>Neptunus (nep-TOO-noos) - neeeeeepppp-TOOOOO-noooooos</span></p>


                                        <p>If banishing, focus on a purification of Neptune’s Archetype within the personal psychology and
                                            energetic being. If invoking, focus on the unity between the self and the self boundary as a total unity allowing the Divine Intelligence of the Higher Being of Neptune to possess and transform.  Hold the sign of silence for at least three full breaths afterward focusing on the purity of the Archetype if
                                            Banishing or allowing the Planetary Intelligence to fully embody if Invoking. </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/school_ritual_psd6_block6_mainWrp_bg_new.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>


                {/* ---------------------------block7------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block7_mainWrp}`} >
                        <div className={styles.common_width}>
                            {/* <div className={styles.column}>
                                <div className={`${styles.col12} ${styles.bgifive}`}>
                                    <h2>
                                        The Pluto Archetype - Divine Intelligence</h2>
                                </div>
                            </div> */}


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h2 ref={thePlutoArchetypeRef}>Pluto Invocation</h2>
                                        <h6>The Pluto Archetype - Divine Intelligence</h6>
                                        <h3>1. Overcoming Destructive Tendencies</h3>

                                        <p>
                                            By consciously banishing traits like obsessions, power struggles, and destructive behaviors, you clear the path for healthier and more constructive engagements with yourself and others. This purification fosters a mindset that seeks growth rather than control, allowing you to engage in transformative practices more openly and effectively.



                                        </p>
                                        <h3>2. Fostering Deep Transformation and Rebirth</h3>



                                        <p>
                                            Invoking Pluto’s qualities such as transformation, rebirth, and empowerment deepens your capacity for profound personal change. As these traits are strengthened, you become more resilient and
                                            capable of navigating life's significant shifts, viewing them as opportunities for growth and renewal.

                                        </p>
                                        <h3>3. Gaining Psychological Insights</h3>
                                        <p>
                                            Engaging in deep self-analysis, psychotherapy, or similar introspective activities enhances your
                                            understanding of your own psychological underpinnings. Pluto’s influence encourages diving deep into the subconscious, uncovering hidden truths and patterns that shape your behavior
                                            and experiences.
                                        </p>
                                        <h3>4. Empowerment Through Self-Mastery</h3>
                                        <p>By embracing change and actively participating in your own transformation, you embody Pluto’s power of empowerment. This process involves not only altering external circumstances but also
                                            fundamentally transforming your internal landscape, leading to a stronger, more self-aware presence.
                                        </p>
                                        <h3>5. Managing Crises and Secrets</h3>
                                        <p>Pluto’s daily influence often manifests in managing crises or navigating complex power dynamics and secrets. By cultivating a balanced approach to these aspects, you enhance your ability to handle
                                            intense situations with composure and insight, using these challenges as catalysts for personal and collective transformation.</p>
                                        <p>Through this ritual praxis, you refine your ability to perceive and integrate the archetypal power of Pluto directly. This integration results in a transformative effect on your ability to handle deep-seated changes, confront and manage crises, and engage in profound psychological work. It encourages a journey towards true empowerment and self-mastery, ultimately leading to a more resilient and
                                            psychologically insightful existence.</p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/school_ritual_psd6_block7_mainWrp_bg.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block8------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block8_mainWrp}`}>
                        <div className={styles.common_width}>



                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        <h6>Ritual Praxis of the Planetary Intelligence</h6>

                                        <p>
                                            Once completing the opening of the gates of water, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of Pluto. Hold for one to three full breaths then make the pronouncement and
                                            resonate the Divine Name of the Planetary Intelligence.


                                        </p>



                                        <p>
                                            <span>Pronouncement: "In nomine Plutonis, custodis subterranei et transformationis,"</span>



                                        </p>
                                        <p><span>Translation: "In the name of Pluto, keeper of the underworld and transformation,"</span></p>
                                        <p><span>Phonetics: "In noh-mee-nay Ploo-toh-nees, kus-toh-dees soob-ter-ray-nee et trahn-sfohr-mah-tee-oh-nees,"</span></p>

                                        <div className={styles.clippathsec}><p>Resonate Divine Name <span>(1 to 3 times)</span></p></div>
                                        <p> <span className={styles.color_white}>Pluto / Latin: </span> <span>Pluto (PLOO-to)  - PLOOOOOOOO-toooooooooooo</span></p>


                                        <p>If banishing, focus on a purification of Pluto’s Archetype within the personal psychology and energetic being. If invoking, focus on the unity between the self and the self boundary as a total unity allowing the Divine Intelligence of the Higher Being of Pluto to possess and transform.  Hold the sign of silence for at least three full breaths afterward focusing on the purity of the Archetype if Banishing or allowing the Planetary Intelligence to fully embody if Invoking.  </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/school_ritual_psd6_block8_mainWrp_bg_new.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block9------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block9_mainWrp}`} >
                        <div className={styles.common_width}>
                            <div className={styles.column} ref={alignmentWithTheZodiacRef}>
                                <div className={`${styles.col12} ${styles.bgifive}`}>
                                    <h2>
                                        Alignment with the Zodiac - the House of the Sun</h2>
                                </div>
                            </div>


                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>

                                        <p>The zodiacal intelligences engaged in this work are <span>states of the Solar Atman</span>—expressions of the Sun’s essential being as it weaves through the heavens. Where the planetary powers act as agents and teachers dwelling within the soul’s architecture, the zodiacal states form the expansive environment, the archetypal atmosphere in which those planetary currents move, unfold, and become visible.</p>

                                        <p>In ritual, each invocation awakens a particular <span>mode of the Atman</span> into conscious presence. The zodiac reveals itself as <span>living landscapes of the soul</span>—fields of vision, emotional terrains, and luminous patterns through which the Solar Atman shapes its expression.</p>

                                        <p>While the following mundane descriptions of the zodiac provide orientation—its qualities, modes, and elemental signatures—the depth of this work arises in <span>theurgical union</span> with the zodiacal state itself. These invocations bring forth personal revelations: not general traits, but <span>direct visions and transformations</span> attuned to the contours of your own being. They refine perception, attune awareness, and illumine the unique ways the Solar Atman radiates through your microcosm.</p>

                                        <p>When aligning with the zodiacal forces, the gates are opened <span>only by invocation</span>, never by banishing. There is nothing to purge within the house of the Sun—there is only <span>pure alignment</span> with the Solar Atman, the personality of the Sun in its phase. All twelve signs are ever-present as conditions of being, yet their influence is most potent when each sign stands in its own season of the year. For this reason, outside of other theurgic operations, it is recommended to perform a ritual of centering on the <span>first day of each zodiacal sign</span>, establishing conscious alignment with its house in the celestial order.</p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/school_ritual_psd6_block9_mainWrp_bg_19Aug.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>

                {/* ---------------------------block10------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block10_mainWrp}`}>
                        <div className={styles.common_width}>



                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        
                                            <h2 ref={ariesInvocationRef}>Aries Invocation (Cardinal Fire)</h2>
                                      

                                        <p>Centering here involves igniting your inner fire with a burst of initiating energy. As a Cardinal sign, Aries represents the spark of new beginnings. You focus on your sense of initiative, courage, and assertiveness, pushing forward with a pioneering spirit. It's about tapping into your raw energy, your drive to take decisive action, and your ability to lead with fierce determination. You visualize a spark within you, growing into a flame of willpower that sets new paths ablaze.</p>
                                        <h6>Ritual Praxis of the Zodiacal House of Sun</h6>
                                        <p>Once completing the opening of the gates of fire, staying still and centralized within the ritual space,
                                            focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of the Cardinal Sun, and within the imaginal being see the sign of Aries ablaze in the center. Hold for one to three full breaths then make the pronouncement and resonate the Divine
                                            Name of the Zodiacal Sign.</p>
                                        <p>Pronouncement: <span>"In nomine Arietis, personae domus Solis, ignis et initiationis."</span></p>
                                        <p>Translation: <span>"In the name of Aries, personality of the House of the Sun, of fire and initiation."</span></p>
                                        <p>Phonetics: <span>"In noh-mee-nay Ah-ree-ay-tees, per-soh-ne doh-moos Soh-lees, ig-nees et in-ee-tee-ah-tee-oh-nees."</span></p>
                                        <p><span  className={styles.color_white}>Resonate Divine Name:</span> <span>Aries / Latin - Aries (AH-ree-ays) - AAAAAAA-reeeeeeee-aysssssssss</span></p>
                                        <p>Focus on the unity between the self and the self boundary as a total unity allowing the Solar House of Ares to possess and transform and bring the self into alignment.  Hold the sign of silence for at least three full breaths afterward focusing on being surrounded on every point by the solar intelligence of Ares.
                                        </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/school_ritual_psd6_block10_mainWrp_bg_new.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>


                {/* ---------------------------block11------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block11_mainWrp}`}>
                        <div className={styles.common_width}>



                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                       
                                            <h2 ref={taurasInvocationRef}>Taurus Invocation (Fixed Earth)</h2>
                                     

                                        <p>Centering in Taurus is about grounding and stabilizing your energy into unwavering persistence. As a Fixed sign, Taurus embodies stability and endurance. You focus on your deep connection to the earth, your sense of security, and your appreciation for the tangible world, holding firm to your values. It's about cultivating patience, sensuality, and a deep sense of rootedness, maintaining a constant and reliable presence. You visualize yourself as a strong, stable tree, drawing unwavering nourishment from the earth.</p>

                                        <h6>Ritual Praxis of the Zodiacal House of Sun</h6>

                                        <p>Once completing the opening of the gates of earth, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of the Fixed Sun, and within the imaginal being see the sign of Taurus ablaze in the center. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Zodiacal Sign.</p>

                                        <p>Pronouncement: <span>"In nomine Tauri, personae domus Solis, terrae et stabilitatis."</span></p>
                                        <p>Translation: <span>"In the name of Taurus, personality of the House of the Sun, of earth and stability."</span></p>
                                        <p>Phonetics: <span>"In noh-mee-nay Tau-ree, per-soh-ne doh-moos Soh-lees, ter-re et sta-bee-lee-tah-tees."</span></p>
                                        <p><span className={styles.color_white}>Resonate Divine Name:</span> <span>Taurus / Latin - Taurus (TAU-rus) - TAAAAAA-uuuuurrrrr-ussssssss</span></p>
                                        <p>Focus on the unity between the self and the self boundary as a total unity allowing the Solar House of Taurus to possess and transform and bring the self into alignment.  Hold the sign of silence for at least three full breaths afterward focusing on being surrounded on every point by the solar
                                            intelligence of Taurus.
                                        </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/school_ritual_psd6_block11_mainWrp_bg_new.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>


                {/* ---------------------------block12------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block12_mainWrp}`}>
                        <div className={styles.common_width}>



                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        
                                            <h2 ref={geminiInvocationRef}>Gemini Invocation (Mutable Air)</h2>
                                     

                                        <p>Centering in Gemini is about adapting your mental energy to flow with change. As a Mutable sign, Gemini represents adaptability and flexibility. You focus on your intellect, your ability to connect with diverse ideas, and your fluid communication. It's about cultivating curiosity, open-mindedness, and a playful spirit, allowing your mind to shift and evolve. You visualize your mind as a clear, flowing stream of information, readily changing its course.</p>

                                        <h6>Ritual Praxis of the Zodiacal House of Sun</h6>

                                        <p>Once completing the opening of the gates of air, staying still and centralized within the ritual space,
                                            focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of the Mutable Sun, and within the imaginal being see the sign of Gemini ablaze in the center. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Zodiacal Sign.</p>

                                        <p>Pronouncement: <span>"In nomine Geminorum, personae domus Solis, aeris et mutationis."</span>
                                        </p>
                                        <p>Translation: <span>"In the name of Gemini, personality of the House of the Sun, of air and change."</span></p>
                                        <p>Phonetics: <span>"In noh-mee-nay Geh-mee-noh-room, per-soh-ne doh-moos Soh-lees, ah-air-ees et moo-tah-tee-oh-nees."</span></p>
                                        <p><span className={styles.color_white}>Resonate Divine Name:</span> <span>Gemini / Latin - Gemini (GEH-mee-nee) - GEHHHHHH-meeeeeee-neeeeeee</span></p>
                                        <p>Focus on the unity between the self and the self boundary as a total unity allowing the Solar House of Gemini to possess and transform and bring the self into alignment.  Hold the sign of silence for at least three full breaths afterward focusing on being surrounded on every point by the solar intelligence of Gemini.
                                        </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/school_ritual_psd6_block12_mainWrp_bg_new.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>



                {/* ---------------------------block13------------------- */}



                <LazySection>
                    <div className={`${styles.school_ritual_horoscope_mainWrp} ${styles.school_ritual_psd6_block13_mainWrp}`}>
                        <div className={styles.common_width}>



                            <div
                                className={`${styles.school_ritual_leo_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}
                            >


                                <div className={styles.school_ritual_txt_box_wrpr}>

                                    <div className={styles.school_ritual_txt_box_innr}>
                                        
                                            <h2 ref={cancerInvocationRef}>Cancer Invocation (Cardinal Water)</h2>
                                       

                                        <p>Centering in Cancer is about initiating emotional connection and nurturing. As a Cardinal sign, Cancer represents the beginning of emotional experience. You focus on your intuition, your empathy, and your connection to your inner world, creating a safe and comforting space. It's about cultivating
                                            compassion, sensitivity, and a sense of belonging, initiating bonds of care and protection. You
                                            visualize yourself as a safe, nurturing harbor, where emotions flow freely.</p>

                                        <h6>Ritual Praxis of the Zodiacal House of Sun</h6>

                                        <p>Once completing the opening of the gates of water, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of the Cardinal Sun, and within the imaginal being see the sign of Cancer ablaze in the center. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Zodiacal Sign.</p>

                                        <p>Pronouncement: <span>"In nomine Cancri, personae domus Solis, aquae et nutritionis."</span>

                                        </p>
                                        <p>Translation: <span>"In the name of Cancer, personality of the House of the Sun, of water and nurturing."</span> </p>
                                        <p>Phonetics: <span>"In noh-mee-nay Kahn-kree, per-soh-ne doh-moos Soh-lees, ah-kwee et noo-tree-tee-oh-nees."</span></p>
                                        <p><span className={styles.color_white}>Resonate Divine Name:</span> <span>Cancer / Latin - Cancer (KAHN-ker) - KAAAAAA-nnnnnn-cerrrrrrr</span></p>
                                        <p>Focus on the unity between the self and the self boundary as a total unity allowing the Solar House of Cancer to possess and transform and bring the self into alignment.  Hold the sign of silence for at least three full breaths afterward focusing on being surrounded on every point by the solar intelligence of Cancer.
                                        </p>
                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>
                                    <img
                                        className={styles.school_ritual_img1}
                                        src="/image/school_ritual_psd6_block13_mainWrp_bg_new.webp"
                                        alt='Image'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </LazySection>





            </div>


        </>
    )
}

export default SchoolRitualBlockSix
